<template>
  <div class="uk-width-1-2@m"
       :class="{'uk-background-default': primary, 'uk-background-secondary': !primary}"
  >
    <div class="uk-padding-large">
      <h4 class="
              uk-text-secondary-muted
              uk-text-uppercase
              uk-text-lighter
              uk-text-medium
              text-spacing-medium uk-margin-small-bottom"
          v-if="subTitle.length > 0"
      >
        {{subTitle}}
      </h4>
      <h3 class="uk-margin-remove-top text-spacing-large
            uk-heading-small uk-text-lighter uk-text-uppercase uk-text-condensed"
          :class="{'uk-text-secondary': !primary }"
      v-html="title"></h3>
      <p :class="{'uk-text-secondary': !primary }">
        <slot/>
      </p>
      <p>
        <router-link :to="buttonLinkParsed" class="
                uk-button
                uk-button-default
                uk-button-large
                uk-margin-medium-top
                "
        >
          {{buttonText}}
        </router-link>
      </p>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'ImageSection',
  props: {
    primary: {
      type: Boolean,
      default: false,
    },
    title: String,
    subTitle: {
      type: String,
      required: String,
    },
    buttonText: {
      required: false,
      type: String,
    },
    buttonLink: {
      required: false,
      type: String,
    },
  },
  computed: {
    buttonLinkParsed() {
      return this.buttonLink ?? '';
    },
  },
});
</script>
